<template>

    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-input-autocomplete
                    :repository="repositories.solicitacao.especialidade"
                    :request-query-string-params="{
                        infraestrutura_solicitante_id: this.infraestruturaSolicitanteId,
                        not_id: especialidadesAdicionadosIds,
                        regulador_id: this.reguladorId,
                        sexo_paciente: this.sexoPaciente,
                    }"
                    :searchFields="fields.autocompleteespecialidade.especialidade"
                    :text-field="i => `${i.codigo} - ${i.nome}`"
                    :validations="validations.especialidade"
                    label="Especialidade"
                    placeholder="Digite o código da ocupação ou o nome da especialidade"
                    resultsLimit="15"
                    v-model="model.especialidade"
                />
            </rkm-col>

            <rkm-col cols="auto">
                <rkm-button
                    :label="false"
                    @click="$refs.Form.validate(add)"
                    color="primary"
                >
                    Incluir
                </rkm-button>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>

// Mixins.
import { repository, error, formats } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {

    computed: {

        fields() {

            return {
                autocompleteespecialidade: {
                     especialidade: [
                        { key: 'especialidade.nome', searchable: true },
                        { key: 'ocupacao.codigo', searchable: true },
                     ]
                },
            }
        },
        validations() {

            return {
                especialidade: { required: true },
            }
        },
        especialidadesAdicionadosIds() {

            return this.especialidadesModal.map(e => e.id)
        }
    },
    created() {

        this.repositories = {
            solicitacao: this.getConectaSusRepository('regulacao.solicitacao'),
        }
    },
    data: () => ({
        model: {
            especialidade: null,
            especialidades: [],
        },
    }),
    methods: {

        ...mapActions(['setLoading', 'unsetLoading']),
        add() {

            if (this.especialidadesModal.length > 0) {

                this.showWarningNotification(
                    'Só é permitido adicionar uma especialidade por solicitação.'
                )

                this.model.especialidade = null;
                return;
            }

            this.especialidadesModal.push(this.model.especialidade);
            this.resetForm();
        },
        resetForm() {

            this.model.especialidade = null;
            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        destroy(especialidade) {

            this.especialidadesModal.splice(this.especialidadesModal.indexOf(especialidade), 1)
        },
    },
    mixins: [repository, error, formats],
    props: {
        especialidadesModal: { type: Array, default: () => [] },
        infraestruturaSolicitanteId: {type: Number, default: null },
        reguladorId: {type: Number, default: null },
        sexoPaciente: { type: [String, Number], default: null },
    },
}
</script>